import React from 'react';

import * as S from './styles';

export const renderWithFocusSentinel = (node: React.ReactNode) => (
  <>
    <S.FocusSentinel />
    {node}
  </>
);
